import { Datagrid, List, NumberField, ReferenceField, TextField } from "react-admin";
import { GenericColorChip } from "shared/components/chips/GenericColorChip";
import CustomDateField from "shared/components/fields/CustomDateField";
import CustomDateInput from "shared/components/inputs/CustomDateInput";
import { SiteResourcesEnum } from "shared/enums/resourceMappings";
import { dsoColorMapping } from "shared/enums/colorMappings/globalColorMappings";

const filters = [<CustomDateInput source="delivery_day" key="delivery_day" alwaysOn mask="dd/MM/yyyy" />];

export const EmaxJGateList = () => (
  <List filters={filters} exporter={false}>
    <Datagrid bulkActionButtons={false}>
      <TextField source="id" />
      <NumberField source="emax_j_gate_id" label={"Emax J Gate ID"} />
      <CustomDateField source="delivery_day" />
      <TextField source="edc_code" />
      <ReferenceField source="site" reference={SiteResourcesEnum.Sites} />
      <NumberField source="quantity" />
      <GenericColorChip source="dso" colorMapping={dsoColorMapping} />
      <CustomDateField source="updated_at" showTime />
    </Datagrid>
  </List>
);
